import { createFileRoute } from '@tanstack/react-router';
import { BusinessContactForm } from '@/components/astro/new-design-25/Business/BusinessContactForm';
import { FAQButton } from '@/components/astro/new-design-25/ui/FAQ-Button';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { Hero } from '@/components/astro/new-design-25/ui/Hero';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import { Testimonials } from '@/components/astro/new-design-25/ui/Testimonials';
import { TryListeningBanner } from '@/components/astro/new-design-25/ui/TryListeningBanner';
import { GridBackground } from '@/components/shared-ui/grid-background';
import * as m from '@/paraglide/messages';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/business')({
  head: () => ({
    meta: [
      ...seo({
        title: m.meta_business_title(),
        description: m.meta_business_description(),
      }),
    ],
    links: [...hreflangLinks('/business')],
  }),
  component: () => (
    <>
      <a
        className='sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4'
        href='#main-content'
      >
        {m.skip_to_main_content()}
      </a>

      <div className='relative'>
        <GridBackground>
          <div className='relative z-10'>
            <NavBar />
            <main id='main-content' tabIndex={-1}>
              <Hero
                badge={m.business_hero_badge()}
                title={m.business_hero_title()}
                description={m.business_hero_description()}
                buttonLabel={m.business_hero_cta()}
                buttonHref='#contact-form'
              />
            </main>
          </div>
        </GridBackground>
      </div>

      <BusinessContactForm />

      <Testimonials />

      <div role='complementary'>
        <FAQButton />
        <TryListeningBanner />
        <Footer />
      </div>
    </>
  ),
});
